import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';
import { NgTemplateOutlet } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TranslatePipe } from '@ngx-translate/core';
import { CardComponent } from '@legacy/common-ui-partials';

import { RichTextWrapperComponent } from '../rich-text-wrapper/rich-text-wrapper.component';

@Component({
  selector: 'wl-error-card',
  templateUrl: './error-card.component.html',
  styleUrls: [
    './error-card.component.essent.scss',
    './error-card.component.ed.scss',
  ],
  standalone: true,
  imports: [
    NgTemplateOutlet,
    AutomationIdDirective,
    FaIconComponent,
    JssModule,
    CSCaptureDirective,
    RichTextWrapperComponent,
    TranslatePipe,
    CardComponent,
  ],
})
export class ErrorCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() titleTranslationKey?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() message?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() messageTranslationKey?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() messageTranslationParams?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() icon?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showDivider = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mode: 'full' | 'body' | 'content' = 'full';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId?: string;
}
